import * as React from 'react';
import { JoyLogo } from '../JoyLogo';
import { Left, Spacer, LogoWrapper, Button } from './styles';

export class JoyHeader extends React.Component {
  static Spacer: React.SFC<{}> = () => <Spacer />;
  static Left: React.SFC<{ onClick?: () => void }> = ({ children, onClick }) => (
    <Left>
      {children}
      {!!onClick ? (
        <Button onClick={onClick}>
          <JoyLogo />
        </Button>
      ) : (
        <JoyLogo />
      )}
    </Left>
  );
  static Right: React.SFC<{}> = ({ children }) => <div>{children}</div>;

  render() {
    const { children, ...props } = this.props;
    return <LogoWrapper {...props}>{children}</LogoWrapper>;
  }
}
